import { BottomTabBar } from '@intigral/ui';
import { useMobileTabs } from '../hooks/useMobileTabs';
import styles from './mobile-tab-bar.module.sass';

export const MobileTabBar = () => {
    const items = useMobileTabs();

    return (
        <>
            <div className={styles.spacer} aria-hidden />
            <BottomTabBar items={items} />
        </>
    );
};
